const ToggleListItemTitleNodeSpec = {
	content: "paragraph",
	selectable:false,
	defining:true,
	toDOM: () => ['div',{class:"doc-toggleListItem-contents-title"},0],
	parseDOM: [{
		tag: 'div.doc-toggleListItem-contents-title'}]
}

export default ToggleListItemTitleNodeSpec